import { render, staticRenderFns } from "./Products.vue?vue&type=template&id=f9c7b4fa&"
import script from "./Products.vue?vue&type=script&lang=js&"
export * from "./Products.vue?vue&type=script&lang=js&"
import style0 from "./Products.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f9c7b4fa')) {
      api.createRecord('f9c7b4fa', component.options)
    } else {
      api.reload('f9c7b4fa', component.options)
    }
    module.hot.accept("./Products.vue?vue&type=template&id=f9c7b4fa&", function () {
      api.rerender('f9c7b4fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/aduanas/management/products/views/Products.vue"
export default component.exports